import React, { useEffect, useState } from 'react';
import './ColorOptions.scss';
import { useSelector } from 'react-redux';
import { v4 } from 'uuid';
import { removeDomainName } from '../../helper';

const ColorOptions = ({
  colorOptions,
  selectedColor,
  setSelectedColor,
  defaultColor,
  onClick,
  PDPColors = false,
  isMobile = false,
}) => {
  const dataLocale = useSelector(state => state.locale);

  const { VIEW_MORE_COLOURS } = dataLocale || {};

  const [colors, setColors] = useState([]);
  const [viewAll, setViewAll] = useState(true);

  useEffect(() => {
    if (colorOptions.length > 3 && !viewAll) {
      const colors = [...colorOptions];
      colors.length = 3;
      setColors(colors);
    } else {
      setColors(colorOptions);
    }
  }, [colorOptions, viewAll]);

  const onClickHandler = productUrl => {
    onClick(productUrl);
  };

  const isSelectedColor = productUrl => {
    return removeDomainName(productUrl) === removeDomainName(window.location.href);
  };

  return (
    <div
      className={`od-pc-colors-container ${PDPColors && isMobile && 'od-pc-colors-container--pdp'}`}
      onMouseLeave={() => setSelectedColor(defaultColor)}
    >
      <div className="od-pc-colors">
        {colors?.map(colorItem => {
          const { color: colorHex, productUrl, frameColorImage: imageUrl } = colorItem;
          // const colors = colorItem.colorHex.split(',');
          return (
            <React.Fragment key={v4()}>
              {PDPColors ? (
                <div
                  className={`od-pc-colors-option ${
                    isSelectedColor(productUrl) ? 'od-pc-colors-option-active' : ''
                  }`}
                  style={{
                    background: imageUrl ? `url(${imageUrl})` : colorHex,
                    backgroundSize: '100% 100%',
                  }}
                  onClick={() => {
                    onClickHandler(productUrl);
                  }}
                  onMouseEnter={() => setSelectedColor(colorHex)}
                />
              ) : (
                <div
                  className={`od-pc-colors-option ${
                    isSelectedColor(productUrl) ? 'od-pc-colors-option-active' : ''
                  }`}
                  onBlur={() => setSelectedColor(defaultColor)}
                  onMouseEnter={() => setSelectedColor(colorHex)}
                  onMouseLeave={() => setSelectedColor(defaultColor)}
                >
                  <div
                    className={`od-pc-colors-option__color-image ${
                      isSelectedColor(productUrl) && 'od-pc-colors-option__color-image--active'
                    }`}
                    style={{
                      background: imageUrl ? `url(${imageUrl})` : colorHex,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center center',
                      backgroundRepeat: 'no-repeat',
                    }}
                  ></div>
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
      {PDPColors && isMobile && !viewAll && colorOptions?.length > 3 && (
        <div
          className="od-pc-more-color-options-text  od-pc-more-color-options-text--mobile"
          onClick={() => setViewAll(!viewAll)}
        >
          {VIEW_MORE_COLOURS}
        </div>
      )}
      {((!PDPColors && !isMobile) || (PDPColors && !isMobile)) &&
        !viewAll &&
        colorOptions?.length > 3 && (
          <div
            className={`od-pc-more-color-options ${
              isMobile ? 'od-pc-more-color-options--mobile' : 'od-font-bold'
            }`}
            onClick={PDPColors ? () => setViewAll(!viewAll) : null}
          >
            +{colorOptions.length - 3}
          </div>
        )}
    </div>
  );
};

export default ColorOptions;
